export enum DimensionTypeEnum {
  Length = 'length',
  Width = 'width',
  Diameter = 'diameter',
}
